import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="silk-hero min-h-[70vh] flex items-center justify-center px-5 py-20">
      <div className="w-full max-w-md silk-card rounded-lg p-8 sm:p-10">
        {sent ? (
          <div data-testid="forgot-password-success">
            <h1 className="font-display text-4xl text-foreground mb-4">Check your inbox</h1>
            <p className="text-sm text-muted-foreground leading-relaxed">
              If an account exists for <span className="text-foreground">{email}</span>, we've sent a link to reset your password. The link expires in 1 hour.
            </p>
            <p className="text-sm text-muted-foreground mt-6">
              Didn't get it? Check your spam folder, or{" "}
              <button onClick={() => setSent(false)} className="cream-link" data-testid="forgot-password-retry-btn">try again</button>.
            </p>
            <p className="text-sm text-muted-foreground mt-6 text-center">
              <Link to="/login" className="cream-link" data-testid="forgot-back-to-login-link">Back to sign in</Link>
            </p>
          </div>
        ) : (
          <>
            <h1 className="font-display text-4xl text-foreground mb-2">Forgot password?</h1>
            <p className="text-sm text-muted-foreground mb-8">Enter your email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <Label htmlFor="email" className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
                <Input id="email" data-testid="forgot-password-email-input" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} className="mt-2" />
              </div>
              <Button data-testid="forgot-password-submit-btn" type="submit" disabled={busy} className="w-full h-11 rounded-full">
                {busy ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <p className="text-sm text-muted-foreground mt-6 text-center">
              Remembered it? <Link to="/login" className="cream-link" data-testid="forgot-login-link">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
